import { createSlice } from '@reduxjs/toolkit';

import { type Fleet } from '../domain/fleet';


// Initial state
const initialState: { list: Fleet[], map: { [key: string]: Fleet } } = { list: [], map: {} };

// Fleets slice
const fleetsSlice = createSlice({
    initialState,
    name: 'fleets',
    reducers: {
        clearFleets: () => initialState,
        setFleets: (state, action) => {
            state.list = action.payload;
            action.payload.forEach((item: Fleet) => {
                state.map[String(item.id)] = item;
            });
        },
    },
});

// Export the action creators and reducer
export const { clearFleets, setFleets } = fleetsSlice.actions;
export default fleetsSlice.reducer;
